function i(u) {
  return u & -u;
}
class f {
  /**
   * @param l length of the array
   * @param min min value of the array
   */
  constructor(t, e) {
    this.l = t, this.min = e;
    const n = new Array(t + 1);
    for (let r = 0; r < t + 1; ++r)
      n[r] = 0;
    this.ft = n;
  }
  /**
   * Add arr[i] by n, start from 0
   * @param i the index of the element to be added
   * @param n the value to be added
   */
  add(t, e) {
    if (e === 0)
      return;
    const { l: n, ft: r } = this;
    for (t += 1; t <= n; )
      r[t] += e, t += i(t);
  }
  /**
   * Get the value of index i
   * @param i index
   * @returns value of the index
   */
  get(t) {
    return this.sum(t + 1) - this.sum(t);
  }
  /**
   * Get the sum of first i elements
   * @param i count of head elements to be added
   * @returns the sum of first i elements
   */
  sum(t) {
    if (t === void 0 && (t = this.l), t <= 0)
      return 0;
    const { ft: e, min: n, l: r } = this;
    if (t > r)
      throw new Error("[FinweckTree.sum]: `i` is larger than length.");
    let s = t * n;
    for (; t > 0; )
      s += e[t], t -= i(t);
    return s;
  }
  /**
   * Get the largest count of head elements whose sum are <= threshold
   * @param threshold
   * @returns the largest count of head elements whose sum are <= threshold
   */
  getBound(t) {
    let e = 0, n = this.l;
    for (; n > e; ) {
      const r = Math.floor((e + n) / 2), s = this.sum(r);
      if (s > t) {
        n = r;
        continue;
      } else if (s < t) {
        if (e === r)
          return this.sum(e + 1) <= t ? e + 1 : r;
        e = r;
      } else
        return r;
    }
    return e;
  }
}
export {
  f as FinweckTree
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/shared/finweck-tree.js
// module id = 991
// module chunks = 67